import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/69eb38d863911b0014f0e4c5/wiretutor/src/app/practice-mode/components/PracticeClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/69eb38d863911b0014f0e4c5/wiretutor/src/components/Sidebar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/69eb38d863911b0014f0e4c5/wiretutor/src/components/Topbar.tsx");
